import React, {Component} from 'react';
import * as PropTypes from 'prop-types';
import {primaryStyles, secondaryStyles} from './styles/Button.css';
import {Link} from 'react-router-dom';
import {ButtonTypes} from "../../constants/Enums";

class Button extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    };
  }

  setHovered = (hovered) => {
    this.setState({hovered});
  };

  getStyles = (buttonType) => {
    let styleParams = {
      hovered: this.state.hovered,
      centered: this.props.centered,
      large: this.props.large
    };

    let additionalStyles = this.props.additionalStyles;

    if (buttonType === ButtonTypes.SECONDARY) {
      let styles = secondaryStyles(styleParams);
      if (additionalStyles) {
        Object.assign(styles, additionalStyles);
      }
      return styles;
    }
    else {
      let styles = primaryStyles(styleParams);
      if (additionalStyles) {
        Object.assign(styles, additionalStyles);
      }
      return styles;
    }
  };

  render() {
    let classNames = "btn";
    if (Array.isArray(this.props.classNames)) {
      this.props.classNames.forEach((className) => {
        classNames += " " + className.toString();
      });
    }

    let type = this.props.type || ButtonTypes.PRIMARY;
    let styles = this.getStyles(type);

    switch (type) {

      case ButtonTypes.LINKSSO:
        return (
          <Link
            className={classNames}
            to={this.props.to}
            style={styles}
            onMouseLeave={() => this.setHovered(false)}
            onMouseEnter={() => this.setHovered(true)}
          >
            {this.props.text}
          </Link>
        );

      default:
        if(this.props.isLink) {
          return (
            <Link to={this.props.to}
                  style={styles}
                  onMouseEnter={() => this.setHovered(true)}
                  onMouseLeave={() => this.setHovered(false)}
                  className={'btn-link ' + classNames}
            >
              {this.props.text}
            </Link>
          )
        }
        else return (
          <button
            className={classNames}
            type={this.props.type}
            style={styles}
            onClick={this.props.action}
            disabled={this.props.disabled}
            onMouseLeave={() => this.setHovered(false)}
            onMouseEnter={() => this.setHovered(true)}
          >
            {this.props.text}
          </button>
        );
    }

  }
}

Button.propTypes = {
  text: PropTypes.string.isRequired,
  action: PropTypes.func,
  classNames: PropTypes.array,
  type: PropTypes.string,
  to: PropTypes.string,
  centered: PropTypes.bool,
  disabled: PropTypes.bool,
  additionalStyles: PropTypes.object,
  isLink: PropTypes.bool,};

export default Button;
